import type { BasicOrganizationUnitsDto, BasicOrganizationUnitsRequestDto } from './models';
import { RestService, Rest } from '@abp/ng.core';
import type { ListResultDto, PagedAndSortedResultRequestDto, PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { GetAvailableRolesInput, GetAvailableUsersInput, GetMembersInput, GetOrganizationUnitInput, IdentityRoleDto, IdentityUserDto, OrganizationUnitCreateDto, OrganizationUnitMoveInput, OrganizationUnitRoleInput, OrganizationUnitUpdateDto, OrganizationUnitUserInput, OrganizationUnitWithDetailsDto } from '../volo/abp/identity/models';

@Injectable({
  providedIn: 'root',
})
export class CareerCompetenciesOrganizationUnitService {
  apiName = 'Default';
  

  addMembers = (id: string, input: OrganizationUnitUserInput, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: `/api/app/career-competencies-organization-unit/${id}/members`,
      body: input,
    },
    { apiName: this.apiName,...config });
  

  addRoles = (id: string, input: OrganizationUnitRoleInput, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: `/api/app/career-competencies-organization-unit/${id}/roles`,
      body: input,
    },
    { apiName: this.apiName,...config });
  

  create = (input: OrganizationUnitCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, OrganizationUnitWithDetailsDto>({
      method: 'POST',
      url: '/api/app/career-competencies-organization-unit',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/app/career-competencies-organization-unit/${id}`,
    },
    { apiName: this.apiName,...config });
  

  get = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, OrganizationUnitWithDetailsDto>({
      method: 'GET',
      url: `/api/app/career-competencies-organization-unit/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getAllBasicAreasByParentArea = (parentArea: BasicOrganizationUnitsRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ListResultDto<BasicOrganizationUnitsDto>>({
      method: 'GET',
      url: '/api/app/career-competencies-organization-unit/basic-areas',
      params: { id: parentArea.id },
    },
    { apiName: this.apiName,...config });
  

  getAvailableRoles = (input: GetAvailableRolesInput, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<IdentityRoleDto>>({
      method: 'GET',
      url: '/api/app/career-competencies-organization-unit/available-roles',
      params: { filter: input.filter, id: input.id, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount, extraProperties: input.extraProperties },
    },
    { apiName: this.apiName,...config });
  

  getAvailableUsers = (input: GetAvailableUsersInput, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<IdentityUserDto>>({
      method: 'GET',
      url: '/api/app/career-competencies-organization-unit/available-users',
      params: { filter: input.filter, id: input.id, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount, extraProperties: input.extraProperties },
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetOrganizationUnitInput, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<OrganizationUnitWithDetailsDto>>({
      method: 'GET',
      url: '/api/app/career-competencies-organization-unit',
      params: { filter: input.filter, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount, extraProperties: input.extraProperties },
    },
    { apiName: this.apiName,...config });
  

  getListAll = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, ListResultDto<OrganizationUnitWithDetailsDto>>({
      method: 'GET',
      url: '/api/app/career-competencies-organization-unit/all',
    },
    { apiName: this.apiName,...config });
  

  getMembers = (id: string, input: GetMembersInput, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<IdentityUserDto>>({
      method: 'GET',
      url: `/api/app/career-competencies-organization-unit/${id}/members`,
      params: { filter: input.filter, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getRoles = (id: string, input: PagedAndSortedResultRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<IdentityRoleDto>>({
      method: 'GET',
      url: `/api/app/career-competencies-organization-unit/${id}/roles`,
      params: { sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getSubAreasByParents = (parents: BasicOrganizationUnitsDto[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, ListResultDto<BasicOrganizationUnitsDto>>({
      method: 'POST',
      url: '/api/app/career-competencies-organization-unit/get-sub-areas',
      body: parents,
    },
    { apiName: this.apiName,...config });
  

  move = (id: string, input: OrganizationUnitMoveInput, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: `/api/app/career-competencies-organization-unit/${id}/move`,
      body: input,
    },
    { apiName: this.apiName,...config });
  

  moveAllUsers = (id: string, targetOrganizationId: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: `/api/app/career-competencies-organization-unit/${id}/move-all-users/${targetOrganizationId}`,
    },
    { apiName: this.apiName,...config });
  

  removeMember = (id: string, memberId: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/app/career-competencies-organization-unit/${id}/member/${memberId}`,
    },
    { apiName: this.apiName,...config });
  

  removeRole = (id: string, roleId: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/app/career-competencies-organization-unit/${id}/role/${roleId}`,
    },
    { apiName: this.apiName,...config });
  

  update = (id: string, input: OrganizationUnitUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, OrganizationUnitWithDetailsDto>({
      method: 'PUT',
      url: `/api/app/career-competencies-organization-unit/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
